import { Fragment } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { RxChevronDown } from 'react-icons/rx'
import { IoIosFootball } from 'react-icons/io'
import { getCompetitionImage } from '../utils/competition'

const DEFAULT_OPTION = {
  text: 'Select Competitions',
  value: '',
  enabled: true,
}

const BUTTON_CLASSES =
  'form-control relative w-full cursor-pointer rounded-lg bg-white py-2 pl-4 pr-10 text-left border border-gray-200 hover:bg-gray-100'

const OPTIONS_CLASSES =
  'absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm z-10'

const OPTION_ROW_CLASSES =
  'flex justify-start gap-4 text-base font-medium items-center text-neutral-800'

const getOptionClassName = ({ active }) =>
  `relative cursor-default select-none py-2 px-4 ${
    active ? 'bg-amber-100 text-amber-900' : 'text-gray-900'
  }`

const CompetitionLogo = ({ logo, name }) => {
  if (!logo) return null

  return (
    <img
      width='30'
      height='30'
      src={getCompetitionImage(logo)}
      alt={name}
      className='rounded border-2 border-neutral-100'
    />
  )
}

const CompetitionSelector = ({
  value,
  onChange,
  competitions,
  defaultOption = DEFAULT_OPTION,
  className = 'min-w-[300px]',
}) => {
  return (
    <Listbox
      value={value}
      onChange={onChange}
    >
      <div className={`relative ${className}`}>
        <Listbox.Button className={BUTTON_CLASSES}>
          <div className='flex gap-2 items-center justify-start'>
            <CompetitionLogo
              logo={value?.logo}
              name={value?.name}
            />
            <span className='block text-sm font-medium tracking-wider'>
              {value ? value.name : defaultOption.text}
            </span>
          </div>
          <span className='pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2'>
            <RxChevronDown
              className='h-5 w-5 text-gray-400'
              aria-hidden='true'
            />
          </span>
        </Listbox.Button>

        <Transition
          as={Fragment}
          leave='transition ease-in duration-100'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <Listbox.Options className={OPTIONS_CLASSES}>
            {defaultOption.enabled && (
              <Listbox.Option
                value={defaultOption.value}
                className={getOptionClassName}
              >
                <div className={OPTION_ROW_CLASSES}>
                  <IoIosFootball className='w-[30px] h-[30px]' />
                  {defaultOption.text}
                </div>
              </Listbox.Option>
            )}
            {competitions.map((comp) => (
              <Listbox.Option
                key={comp.id}
                value={comp}
                className={getOptionClassName}
              >
                <div className={OPTION_ROW_CLASSES}>
                  <CompetitionLogo
                    logo={comp.logo}
                    name={comp.name}
                  />
                  {comp.name}
                </div>
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  )
}

export default CompetitionSelector
